import { Heading4 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledItem,
  StyledItems,
  StyledRole,
  StyledSection
} from './GenderHighlight.styled';

const GenderHighlight: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const items = [
    {
      role: t('gender.highlight.product-design'),
      icon: getPublicPath('/images/stateSector/design.svg')
    },
    {
      role: t('gender.highlight.product-managament'),
      icon: getPublicPath('/images/stateSector/product.svg')
    },
    {
      role: t('gender.highlight.qa'),
      icon: getPublicPath('/images/stateSector/software-engineering.svg')
    },
    {
      role: t('gender.highlight.data-analysis'),
      icon: getPublicPath('/images/stateSector/operations.svg')
    }
  ];

  return (
    <StyledSection>
      <StyledContainer>
        <Heading4>{t('gender.highlight.title')}</Heading4>
        <StyledItems>
          {items.map((item, index) => (
            <StyledItem key={index}>
              <img src={item.icon} alt="" />
              <StyledRole>{item.role}</StyledRole>
            </StyledItem>
          ))}
        </StyledItems>
      </StyledContainer>
    </StyledSection>
  );
};

export default GenderHighlight;
